var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid p-0 h-100"},[_vm._m(0),_c('div',{staticClass:"main-content"},[_c('b-card',{staticClass:"response-content p-0 shadow-none",attrs:{"no-body":""}},[_vm._t("default")],2)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('img',{staticClass:"sidebar-logo",attrs:{"src":"/static/img/logo/small.png"}})])
}]

export { render, staticRenderFns }